<ng-container *rbac="rbacProperty; else pureTpl">
  <ng-container *ngIf="displayData; else empty">
    <a [routerLink]="link" [ngClass]="customClass">
      {{ displayData }}
      <ng-container *ngIf="displayData && relationData">
        &nbsp;&nbsp;<span class="text-color text-color--gray">/ &nbsp;{{ relationData }}</span>
      </ng-container>
    </a>
  </ng-container>
</ng-container>

<ng-template #pureTpl>
  <ng-container *ngIf="displayData; else empty">
    {{ displayData }}
    <ng-container *ngIf="relationData && !rbacService.can(rbacProperty)">
      &nbsp;&nbsp;<span class="text-color text-color--gray">/ &nbsp;{{ relationData }}</span>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #empty>
  <gtd-ui-field-empty-component></gtd-ui-field-empty-component>
</ng-template>
